<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[1]" :innerTitle="navList[1].navChildList[0].name" :innerLink="navList[1].navChildList[0].toLink"></inner-nav>
      <div class="new-content">
        <div class="new-detail">
          <div class="new-title">
            <h1>{{introductionInfo.title}}</h1>
            <h3>{{introductionInfo.englishTitle}}</h3>
          </div>
          <div class="new-describe" v-html="introductionInfo.content">
              {{introductionInfo.content}}
          </div>
        </div>
        <div class="new-img">
          <img v-for="(item,index) in adList" :key="index" :src="item.imgUrl" alt="">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  import {mapGetters,mapActions} from "vuex";

  export default {
    name: "",
    data(){
      return {
        introductionInfo:{}
      }
    },
    components: {
      ad,
      InnerNav
    },
    computed: {
      ...mapGetters(['adList'])
    },
    methods:{
      ...mapActions(['adListFn'])
    },
    created(){
      this.adListFn();
      this.$http.get(`/outer/announcement/listAnnouncements.do`, {
        functionCode:4
      }).then((res)=>{
        this.introductionInfo=res.data.list[0]
      })
    }

  }
</script>

<style scoped lang="less">
  .new-content{
    overflow: hidden;
    clear: both;
    padding-top:.3rem;
  .new-detail{
    width:7.7rem;
    padding-bottom:.3rem;
    float: left;
  .new-title{
  h1{
    font-size:.24rem;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:.48rem;
  }
  h3{
    font-size:.14rem;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:.14rem;
  }
  }
  .new-describe{
    padding-top: .3rem;
    color: #666666;
    font-size:.12rem;
    line-height:.32rem;
    text-align: justify;
      span{
        font-size:.12rem;
      }
    img{
      width:7.7rem;
      height:2.8rem;
      margin: .1rem 0;
    }
  }

  }
  .new-img{
    width:4rem;
    float: right;
  img{
    width: 4rem;
    height:2.6rem;
    margin-top:.1rem;
  }
  }
  }


</style>



// WEBPACK FOOTER //
// src/pages/group/introduction.vue